export default "__VITE_ASSET__CDwwxCur__"